import React, {Component}  from 'react';
import {Route, Switch} from 'react-router-dom';
import {view as Mission} from './mission_list'
import {view as MissionDetail} from './mission_detail'
import {view as ErrorDuty} from './error_duty'

class QuestionBox extends Component{
    render(){
        return(
            <div style={{paddingLeft:'10px',fontSize:0,marginRight:'10px',paddingTop:'10px'}}>
                <div>
                    <Switch>
                        <Route exact path="/questionbox" component={Mission}/>
                        <Route exact path="/questionbox/detail/(.*)" component={MissionDetail}/>
                        <Route exact path="/questionbox/duty/(.*)" component={ErrorDuty}/>
                    </Switch>
                </div>
            </div>
        );
    }
}



export default QuestionBox


// WEBPACK FOOTER //
// ./src/entry_app/question_box/view.js